module.exports = __webpack_public_path__ + "img/check_new.7abf4547.svg";